var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    { attrs: { height: "1600" } },
    [
      _c("polygon", {
        staticClass: "fill-current",
        attrs: {
          points:
            "1367.28 2500 1.43 2500 1.43 331.86 1367.28 191.8 1367.28 2500"
        }
      }),
      _c("path", {
        staticClass: "fill-current",
        attrs: {
          d:
            "M0,278.42,1.05,493l1366.23-245.9L1367,72.46,1195.64,0,864.1,133.89,682,63.41S344.08,190,341.46,189.82s-161.61-61.33-161.61-61.33Z"
        }
      }),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }